import React, { useState } from 'react'

import { Helmet } from 'react-helmet-async';
import { useAuth0 } from '@auth0/auth0-react';
import styles from './BlockedPage.module.sass';
import logoAnimated from 'Assets/Icons/logo-animated.svg';
import Button from 'Components/Atoms/Button/Button';

export const BlockedPage = () => {
    const { loginWithRedirect } = useAuth0();
    
    return <>
        <Helmet>
            <title>Je bent geblokeerd - Growing People</title>
        </Helmet>

        <div className={styles.container}>
            <img src={logoAnimated} width="300px" />

            <div className={styles.message}>Het mailadres waarmee je probeert in te loggen is geblokeerd.</div>

            <Button
                variant='transparent'
                color='primary'
                onClick={() => loginWithRedirect()}
            >
                Probeer een ander mailadres
            </Button>
        </div>
    </>;
}